import { Scale, FileText, Shield, Cookie, BookMarked, Copyright } from 'lucide-react';
import SettingCard from '../../components/settings/SettingCard';
import SettingsRow from '../../components/settings/SettingsRow';

const OPEN_SOURCE = [
  { name: 'React', license: 'MIT' },
  { name: 'React Router', license: 'MIT' },
  { name: 'Tailwind CSS', license: 'MIT' },
  { name: 'lucide-react', license: 'ISC' },
  { name: 'Recharts', license: 'MIT' },
  { name: 'Zustand', license: 'MIT' },
  { name: 'Firebase JS SDK', license: 'Apache-2.0' },
];

export default function Legal() {
  return (
    <div className="space-y-6">
      <div className="hidden lg:block">
        <h1 className="text-2xl font-bold tracking-tight">Legal</h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400">Terms, privacy and licenses</p>
      </div>

      <SettingCard title="Policies" flush>
        <SettingsRow icon={FileText} label="Terms of Service" description="The rules for using Messego" to="/terms" />
        <SettingsRow icon={Shield} label="Privacy Policy" description="How we handle your data" to="/privacy" />
        <SettingsRow icon={Cookie} label="Cookie Policy" description="How we use cookies" to="/cookies" />
        <SettingsRow icon={BookMarked} label="Community Guidelines" description="Keeping Messego safe and respectful" onClick={() => window.open('https://messego.com', '_blank', 'noreferrer')} />
      </SettingCard>

      <SettingCard title="Open-source licenses" icon={Copyright} description="Messego is built with these great projects">
        <ul className="divide-y divide-neutral-100">
          {OPEN_SOURCE.map((lib) => (
            <li key={lib.name} className="flex items-center justify-between py-3 text-sm">
              <span className="font-medium text-neutral-800">{lib.name}</span>
              <span className="text-xs text-neutral-500 dark:text-neutral-400 font-mono">{lib.license}</span>
            </li>
          ))}
        </ul>
      </SettingCard>

      <p className="flex items-center gap-2 text-xs text-neutral-400 dark:text-neutral-500 px-2">
        <Scale className="w-3.5 h-3.5" />
        © {new Date().getFullYear()} Messego, Inc. All rights reserved.
      </p>
    </div>
  );
}
